import { Button } from '@material-ui/core';
import React, { useContext } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faMinus, faShoppingCart } from '@fortawesome/free-solid-svg-icons'
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { CountContext, UserContext } from '../../App';


const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      width: '400px',
      marginLeft: '300px',
      marginBottom: '100px',
      marginTop: '50px',
      backgroundColor: theme.palette.background.paper,
    },
  }));

const MealItem = () => {
    const [mealItem, setMealItem] = useState({});
    const [others, setOthers] = useState([]);
    const [count, setCount] = useContext(CountContext);
    const { id } = useParams()
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const {food_image, food_name, food_description, price, food_type} = mealItem;
    const [loggedInUser, setLoggedInUser] = useContext(UserContext);

    const handleChange = (event, newValue) => {
    setValue(newValue);
    };

    useEffect(() => {
        fetch('https://red-onion-server-01.herokuapp.com/meal/' + id)
        .then(res => res.json())
        .then(data => setMealItem(data))
    }, [id])

    useEffect(() => {
        fetch('https://red-onion-server-01.herokuapp.com/' + food_type)
        .then(res => res.json())
        .then(data => setOthers(data));
    }, [food_type])

    const addOrder = () => {
        const user = loggedInUser.email
        const order = {food_image, food_name, price, count, user }
        fetch('https://red-onion-server-01.herokuapp.com/addOrder', {
            method: "POST",
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            },
            body: JSON.stringify(order)
        })
    }

    return (
        <div>
            <div className="d-flex justify-content-center align-items-center container" style={{marginTop: '100px'}}>
            <div className="col-md-6">
                <h1 style={{color: 'black'}}>{food_name}</h1>
                <p style={{color: '#A1A1A1'}}>{food_description}</p>
                <div className="d-flex">
                    <h1>${price}</h1>
                    <div style={{border: '1px solid rgb(228, 217, 217)', display: 'inline-block', padding: '9px 18px', borderRadius: '25px', height: '50px', marginTop: '5px', marginLeft: '15px'}}>
                    <button style={{background: 'transparent', border: 'none'}}><FontAwesomeIcon icon={faMinus}  style={{color: '#F91944'}} onClick={() => (count > 1) && setCount(count - 1)}/></button>
                    <input type="text" value={count} style={{width: '50px', border: 'none', textAlign: 'center', color: 'black'}} disabled />
                    <button style={{background: 'transparent', border: 'none'}}><FontAwesomeIcon icon={faPlus} style={{color: '#F91944'}} onClick={() => setCount(count + 1)}/></button>
                    </div>
                </div>
                <Button variant="contained" color="secondary" style={{padding: '12px 35px', borderRadius: '25px', marginTop: '20px'}} onClick={addOrder}><FontAwesomeIcon icon={faShoppingCart} style={{marginRight: '10px'}}/> Add</Button>
            </div>
            <div className="col-md-6" style={{marginLeft: '100px'}}>
                <img src={food_image} alt="" className="w-100"/> 
            </div> 
            </div>
            <div className={classes.root}>
                <AppBar position="static" color="transparent" style={{boxShadow: 'none'}}>
                <Tabs
                value={value}
                onChange={handleChange}
                indicatorColor="transparent"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable auto tabs example"
                >
                {
                    others.map(meal => <Link to={`/meal/${meal._id}`}><Tab icon={<img src={meal.food_image} style={{width: '100%'}} />} style={{opacity: '1'}}/></Link>)
                }
                </Tabs>
                </AppBar>
            </div>
        </div>
    );
};

export default MealItem;